var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail',{attrs:{"onManager":_vm.onManager,"data":_vm.data,"extra-info":_vm.extraInfo,"base-info":_vm.baseInfo,"on-manager":_vm.onManager,"name-props":{ edit: false },"desc-props":{ edit: false }}})}
var staticRenderFns = []

export { render, staticRenderFns }